import React from 'react';
import { Alert } from '@ds/react-components';
import * as Styled from './NoPermissionError.styled';

const NoPermissionError = (props) => {
  return (
    <Styled.InfoAlert variant={'warning'} dismissible={false}>
      <Alert.AlertMessage>
        {'We are sorry, but you do not have permission to cancel this account.'}
      </Alert.AlertMessage>
    </Styled.InfoAlert>
  );
};

NoPermissionError.propTypes = {};

export default NoPermissionError;
